/**
 * Labstep
 *
 * @module components/ProtocolStep/List
 * @desc List of ProtocolStep
 */

import { ProtocolStepItem } from 'labstep-web/components/ProtocolStep/Item';
import { List } from 'labstep-web/core/List';
import type React from 'react';
import type { IProtocolStepListProps } from './types';

export const ProtocolStepList: React.FC<IProtocolStepListProps> = ({
  protocolSteps,
  protocol,
  protocolCollection,
}) => (
  <List
    id="protocol-step-list"
    data-cy="components/ProtocolStep/List"
  >
    {protocolSteps.map((protocolStep, index) => (
      <ProtocolStepItem
        key={protocolStep.guid}
        protocol={protocol}
        protocolCollection={protocolCollection}
        protocolStep={protocolStep}
        index={index}
      />
    ))}
  </List>
);
